import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import styles from "./styles/Dashboard.module.css";
import { NotificationFilter } from "./components/notification/NotificationFilter";
import { NotificationList } from "./components/notification/NotificationList";
import AdsComponents from "./components/ads/AdsComponents";
import { baseAxios } from "./apis";
import { transformNotifications } from "./utils";
import Layout from "./components/ui/Layout";

// --- DATA DUMMY DITAMBAHKAN DI SINI ---
// const masterNotificationsData = [
//   {
//     id: 1,
//     botName: "Xenoarc-Simple Bot",
//     icon1:
//       "https://cdn.builder.io/api/v1/image/assets/TEMP/4da79bc120b2adf00fed6f6159aed7bb8a4f35d4a1f8a109f1ad6b71d75cb6f0?placeholderIfAbsent=true",
//     icon2:
//       "https://seeklogo.com/images/B/binance-logo-04F5342934-seeklogo.com.png",
//     timestamp: "27/06/2025 09:10",
//     title: "Limit order filled",
//     description: "Sell 0.001010 BTC at 100,000.00 USDT",
//     isRead: false,
//     type: "system",
//   },
//   {
//     id: 2,
//     botName: "DCA Bot",
//     icon1:
//       "https://cdn.builder.io/api/v1/image/assets/TEMP/4da79bc120b2adf00fed6f6159aed7bb8a4f35d4a1f8a109f1ad6b71d75cb6f0?placeholderIfAbsent=true",
//     icon2: "https://seeklogo.com/images/O/okx-logo-E5OKEX-A52874.svg",
//     timestamp: "25/06/2025 12:30",
//     title: "Market Price Above",
//     description: "Market price is above BOT's maximum price or minimum price",
//     isRead: true,
//     type: "system",
//   },
//   {
//     id: 3,
//     timestamp: "27/06/2025 08:00",
//     title: "System Maintenance Scheduled",
//     description: "We will be undergoing scheduled maintenance on Dec 28, 2024.",
//     isRead: false,
//     type: "announcement",
//   },
//   {
//     id: 4,
//     timestamp: "20/06/2024 18:30",
//     title: "New Feature: Trailing Stop Loss",
//     description:
//       "Trailing Stop Loss is now available for all spot trading bots.",
//     isRead: true,
//     type: "announcement",
//   },
// ];

// 1. Create a custom hook for fetching and filtering notifications
const useNotificationsQuery = (filters) => {
  return useQuery({
    // The query key includes the filters object.
    // React Query will automatically refetch when this object changes.
    queryKey: ["notifications", filters],
    queryFn: async () => {
      // Build params object conditionally to avoid sending empty values
      const params = {};
      if (filters.dateStart) params.date_start = filters.dateStart;
      if (filters.dateEnd) params.date_end = filters.dateEnd;
      if (filters.search) params.search = filters.search;
      if (filters.exchange_id) params.exchange_id = filters.exchange_id;
      if (filters.strategy_name) params.strategy_name = filters.strategy_name;

      const { data } = await baseAxios.get("/api/notifications/read_all", {
        params,
      });
      return data;
    },
    // Use the `select` option to transform the data after fetching
    select: (data) => transformNotifications(data),
  });
};

export const Notifications = () => {
  // 2. Keep the state for the filters, as they are controlled by the UI
  const [selectedExchange, setSelectedExchange] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [search, setSearch] = useState("");
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);

  // 3. REMOVE the manual data and loading states
  // const [notifications, setNotifications] = useState([]);
  // const [loading, setLoading] = useState(false);

  // 4. REMOVE the data-fetching useEffect
  // useEffect(() => { ... }, [selectedExchange, ...]);

  // 5. Call our new hook with the filters object
  const { data: notifications, isLoading: loading } = useNotificationsQuery({
    exchange_id: selectedExchange?.id,
    strategy_name: selectedType?.name?.toLowerCase(),
    search,
    dateStart,
    dateEnd,
  });

  // const displayedNotifications = useMemo(() => {
  //   return masterNotificationsData
  //     .filter((notif) => {
  //       if (!selectedType) return true;
  //       return notif.type === selectedType.toLowerCase();
  //     })
  //     .filter((notif) => {
  //       if (!search) return true;
  //       const searchText = search.toLowerCase();
  //       return (
  //         notif.title.toLowerCase().includes(searchText) ||
  //         notif.description.toLowerCase().includes(searchText)
  //       );
  //     });
  // }, [selectedType, search, dateStart, dateEnd, selectedExchange]);

  return (
    <Layout>
      <div>
        <div>
          <h1 className="text-3xl text-left font-bold text-gray-900 mb-6">
            Notifications
          </h1>
          <NotificationFilter
            selectedExchange={selectedExchange}
            setSelectedExchange={setSelectedExchange}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            setSearch={setSearch}
            setDateStart={setDateStart}
            setDateEnd={setDateEnd}
          />
          {/* The NotificationList component now receives data directly from our hook */}
          <NotificationList
            notifications={notifications || []}
            loading={loading}
          />
          <div
            className={`w-full bg-white rounded-xl flex h-[200px] my-5`}
            style={{ border: "1px solid #dde1e6" }}
          >
            <AdsComponents />
          </div>
        </div>
      </div>
    </Layout>
  );
};
